var INITIAL_STATUS = 'EMPTY';
var INITIAL_ERROR = 'NULL';
export var INITIAL_CREDROW = {
    info_provider_api: '',
    info_provider: '',
    status: INITIAL_STATUS,
    apiStatus: INITIAL_STATUS,
    error: INITIAL_ERROR,
    username: '',
    other_login: '',
    password: '',
    credential_id: '',
    establishments: [],
    automatic_renewal: false,
    has_unassigned_estabs: true
};
